import { Brand } from './Brand.model';
import { ModuleBrandName } from './ModuleBrandNames.model';
import { ModuleType } from './ModuleType.model';

export class Module {
  moduleId: string;
  code: string;
  neowiseCode: string;
  name: string;
  moduleTypeId: string;
  moduleType: ModuleType;
  licenseActivationRuleId: string;
  brandId: string;
  moduleCategoryId: string;
  shortDescription: string;
  description: string;
  imageCover: string;
  brochureImages: string;
  priority: number;
  deleted: number;
  moduleBrandNames: ModuleBrandName[];

  constructor(params: ModelParams) {
    this.moduleId = params.moduleId;
    this.code = params.code;
    this.neowiseCode = params.neowiseCode;
    this.name = params.name;
    this.deleted = params.deleted;
    this.moduleTypeId = params.moduleTypeId;
    this.licenseActivationRuleId = params.licenseActivationRuleId;
    this.brandId = params.brandId;
    this.moduleCategoryId = params.moduleCategoryId;
    this.shortDescription = params.shortDescription;
    this.description = params.description;
    this.imageCover = params.imageCover;
    this.brochureImages = params.brochureImages;
    this.priority = params.priority;

    this.moduleType = params.moduleType && new ModuleType(params.moduleType);
    this.moduleBrandNames = params?.moduleBrandNames?.map((mbn) => new ModuleBrandName(mbn));
  }
}

export interface ModelParams {
  moduleId: string;
  code: string;
  neowiseCode: string;
  name: string;
  moduleTypeId: string;
  moduleType: ModuleType;
  licenseActivationRuleId: string;
  brandId: string;
  moduleCategoryId: string;
  shortDescription: string;
  description: string;
  imageCover: string;
  brochureImages: string;
  priority: number;
  deleted: number;
  moduleBrandNames: ModuleBrandName[];
}
